import { useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

export default function Signup() {


  const [hide, setHide] = useState(true);
  const [password, setPassword] = useState("");
  let navigate = useNavigate();


  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
    console.log(e.target.value)
  }


  return (
    <div style={{ fontFamily: 'Montserrat' }} className='h-screen w-screen flex bg-gradient-to-t from-blue-900 to-blue-400 items-center justify-center'>

      <div className="flex flex-col justify-center items-center">

        <div className="w-72 md:w-2/5 backdrop-blur-sm rounded-md">
          <img src="/logo.png" />
        </div>

        <div className="mt-24 text-white font-bold text-2xl">
          Enter Super User Password
        </div>



        <div className="mt-10 flex flex-row bg-white">
          <input
            onChange={(e) => handlePasswordChange(e)}
            type={hide === true ? "password" : "text"}
            placeholder="Password"
            className="md:w-5/6 w-4/6 text-black font-normal text-md bg-black/10 p-3 rounded-sm" />
          <button
            onClick={() => {
              setHide(!hide);
            }}
            className="md:w-1/6 w-2/6 bg-black/10 flex justify-center items-center">
            👁️
          </button>
        </div>


        <button
          onClick={() => {
            if(password=="testing"){
              navigate("/admin");
              localStorage.setItem('admin', "true");
            }
            else{
              swal("Wrong Password");
            }
          }}
          className="shadow-xl hover:scale-105 mt-12 w-48 text-blue-900 font-bold text-xl bg-white p-2 rounded-sm">
          Log In
        </button>





      </div>

    </div>
  )
}